<script lang="ts">
	import VisibilityIcon from "@svg/VisibilityIcon.svelte";
	import VisibilityOffIcon from "@svg/VisibilityOffIcon.svelte";

	let visible = false;
	
	function toggleVisibility(event: MouseEvent) {
		visible = !visible;
		// Get the closest parent with class input-icon-container and then find the input within it
		const container = (event.target as HTMLElement).closest('.input-icon-container');
		const input = container?.querySelector('input') as HTMLInputElement;
		if (input) {
			input.type = visible ? 'text' : 'password';
		}
	}
</script>

<button
	type="button"
	on:click|stopPropagation={toggleVisibility}
	class="flex items-center justify-center"
>
	{#if !visible}
		<VisibilityIcon class="h-5 w-5" />
	{:else}
		<VisibilityOffIcon class="h-5 w-5" />
	{/if}
</button>
